var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSxp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M12 24c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12C5.372 0 0 5.372 0 12c0 6.627 5.372 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.566 4.329a3.05 3.05 0 0 0-1.835.9c-.368.364-.716.738-1.089 1.106-.186.191-.375.377-.563.566-.189.19-.397.39-.593.588-.195.198-.358.372-.54.556-.283.284-.566.567-.849.853-.217.224-.43.456-.644.68-.127.134-.263.258-.383.4a3.362 3.362 0 0 0-.759 2.268c.01.446.127.884.342 1.275.122.237.263.463.422.676.105.148.182.146.32.031a.687.687 0 0 0 .074-.071c.136-.144.27-.287.409-.43.196-.206.396-.411.592-.619.196-.208.408-.437.614-.652.098-.105.202-.202.3-.306.21-.222.416-.45.626-.67.21-.22.423-.426.629-.64.205-.215.458-.478.69-.717.23-.239.427-.44.642-.66.28-.288.552-.585.829-.873.172-.177.348-.347.52-.521.239-.239.461-.478.695-.716.235-.239.409-.4.61-.605.448-.453.896-.909 1.343-1.367a.963.963 0 0 0 .08-.09c.11-.14.12-.17-.016-.268a4.284 4.284 0 0 0-.664-.43 3.12 3.12 0 0 0-1.321-.294h-.023c-.153 0-.305.01-.456.029l-.003-.003v.004Zm3.952 2.94h-.029a1.348 1.348 0 0 0-1.03.477.981.981 0 0 1-.07.072l-.731.716c-.24.24-.497.5-.748.75-.208.208-.416.411-.62.62-.206.207-.426.439-.648.656l-.688.669-.814.821-1.514 1.514-2.004 2.011c-.129.127-.131.143 0 .28.32.323.645.644.955.97.192.204.445.339.721.385.26.052.53.043.786-.027.192-.047.37-.141.516-.274l.793-.766c.186-.179.375-.356.559-.538.367-.364.73-.73 1.098-1.092.299-.294.605-.585.908-.879l1.243-1.211c.387-.38.776-.762 1.168-1.142a.256.256 0 0 1 .45.05 1.747 1.747 0 0 1 .296 1.168c-.032.355-.178.69-.417.955-.287.309-.592.6-.89.896-.213.21-.43.416-.643.628-.274.272-.544.55-.819.822-.04.045-.078.093-.121.136l-.27.28c-.202.202-.408.398-.607.6-.199.204-.427.44-.64.662-.018.021-.04.036-.059.055-.239.222-.459.445-.685.668-.108.106-.21.213-.316.318-.181.184-.367.364-.542.552-.107.112-.107.181.02.27.208.16.429.3.661.422a3.333 3.333 0 0 0 1.846.263 3.018 3.018 0 0 0 1.672-.762c.353-.31.669-.66.998-.993.239-.24.478-.495.733-.74l.69-.696c.21-.212.418-.425.631-.635.213-.21.478-.46.716-.698.24-.236.478-.477.717-.73a5.66 5.66 0 0 0 .526-.621c.298-.45.484-.966.542-1.502a3.327 3.327 0 0 0 0-.803 3.355 3.355 0 0 0-.504-1.33 3.859 3.859 0 0 0-.668-.769 126.59 126.59 0 0 1-1.968-1.99 1.505 1.505 0 0 0-1.119-.499h-.009l-.071.01h-.001Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 1.635,
    x2: 20.895,
    y1: 5.035,
    y2: 18.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9914"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSxp);
export default __webpack_public_path__ + "static/media/sxp.0159e9f11785d08e407ff7e1a4f071bc.svg";
export { ForwardRef as ReactComponent };